import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import DashboardAdmin from "./pages/DashboardAdmin";
import TokenRedirect from "./pages/TokenRedirect";
import DetailAml from "./pages/DetailAml";

function ProtectedRoute() {
  const user = useSelector((state) => state.user?.redux_object || null);

  // Se non autenticato - redirect
  if (!user?.accessToken) {
    window.location.href = process.env.REACT_APP_RETURN_LEXIA_TOOLS;
    return null;
  }

  // Se autenticato
  return <Outlet />;
}

function App() {
  const user = useSelector((state) => state.user?.redux_object || null);
  console.log(user);
  return (
    <>
      <Routes>
        <Route path="/token-login" element={<TokenRedirect />} />

        {/* Rotte protette AML */}
        <Route element={<ProtectedRoute />}>
          <Route
            path="/"
            element={<Navigate to="/aml/moduli-in-raccolta" replace />}
          />

          <Route path="/aml/moduli-in-raccolta" element={<DashboardAdmin />} />

          <Route path="/aml/moduli-validi" element={<DashboardAdmin />} />

          <Route path="/aml/moduli-scaduti" element={<DashboardAdmin />} />

          <Route path="/aml/ricerca-moduli" element={<DashboardAdmin />} />

          <Route path="/aml/:id" element={<DetailAml />} />

          {/* Catch-all - rotta non esistente */}
          <Route
            path="*"
            element={<Navigate to="/aml/moduli-in-raccolta" replace />}
          />
        </Route>
      </Routes>
    </>
  );
}

export default App;
